import React, { useState } from 'react';

import SatDataGrid from '@components/common/satUI/SatDataGrid';

import { getDateByformat } from '@common/utils/date';

const ThankyouCallGuideList = props => {
  const { thankyouCallGuideList, scriptContent } = props;

  const columns = [
    {
      title: '통화(처리)일',
      dataIndex: 'receiptDate',
      key: 'receiptDate',
      width: '25%',
      setColumnStyle: 'text-center vertical-t',
      render: value => {
        return (
          <span className="t-date c-gray">
            {getDateByformat(value, 'yyyy.MM.dd')}
          </span>
        );
      },
    },
    {
      title: '세부내용',
      dataIndex: 'scriptContent',
      key: 'scriptContent',
      width: '75%',
      render: value => {
        return (
          <>
            {/* <p className="mgt-20"> */}
            {scriptContent && (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    scriptContent && scriptContent.replaceAll('\n', '<br />'),
                }}
              />
            )}
            {!scriptContent && (
              <div
                dangerouslySetInnerHTML={{
                  __html: value && value.replaceAll('\n', '<br />'),
                }}
              />
            )}

            {/* </p> */}
          </>
        );
      },
    },
  ];

  return (
    <>
      <h2 className="tit-con">필수사항 미안내 내용</h2>
      {/* <!-- Scroll Table --> */}
      <div
        className="thead-fix-scroll"
        style={{ height: 'auto', maxHeight: '28rem' }}
      >
        <SatDataGrid
          columns={columns}
          dataSource={thankyouCallGuideList}
          customStyleClass="bd-b-fix2"
          noDataRender={'통화 후 이력을 확인 하실 수 있어요.'}
        />
      </div>
    </>
  );
};

export default ThankyouCallGuideList;
